const createUUID = () => {
  const base = Number.MAX_SAFE_INTEGER;
  return Math.floor(Math.random() * base).toString(36) + Math.abs(Date.now()).toString(36);
};

const forEach = (items, fn) => {
  const length = items.length;
  if (!length) return;
  let idx = -1;

  while (++idx < length) {
    if (fn(items[idx], idx) === false) break;
  }
};

const getTypeTag = value => Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
const isPlainObject = value => getTypeTag(value) === "object";
const isEmptyObject = value => {
  if (!isPlainObject(value)) return false;

  for (let key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      return false;
    }
  }

  return true;
};
const isFunction = value => getTypeTag(value) === "function";
const isString = value => getTypeTag(value) === "string";
const isUndefined = value => getTypeTag(value) === "undefined";

const camelToKebab = value => value && value.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(x => x.toLowerCase()).join("-");
const kebabToCamel = value => value && value.split("-").map((word, i) => i > 0 ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word.toLowerCase()).join("");

const sanitizeString = value => {
  const dump = document.createElement("div");
  dump.textContent = value;
  return "" + dump.innerHTML;
};

function log(msg) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "warn";
  console[type]("[BulbaElement]: ".concat(msg));
}

const Attributes = {
  dir: "dir"
};
const AttributeValues = {
  ltr: "ltr"
};
const External = {
  bulbaIdProperty: "bulbaId",
  requestRender: "requestRender",
  render: "render",
  staticProperties: "properties",
  staticStyles: "styles",
  bulbaIdAttribute: "bulba-id",
  onConnect: "onConnect",
  onMount: "onMount",
  onUpdate: "onUpdate",
  onPropertyChange: "onPropertyChange",
  onAttributeChange: "onAttributeChange",
  onUnmount: "onUnmount"
};
const Internal = {
  bulbaId: Symbol("#bulbaId"),
  vnode: Symbol("#vnode"),
  isFirstRender: Symbol("#isFirstRender"),
  reflectMap: Symbol("#reflectMap"),
  renderer: Symbol("#renderer"),
  initialize: Symbol("#initialize"),
  schedule: Symbol("#schedule"),
  runLifecycle: Symbol("#runLifecycle"),
  upgrade: Symbol("#upgrade"),
  upgradeProperties: Symbol("#upgradeProperties"),
  renderStyles: Symbol("#renderStyles"),
  renderDOM: Symbol("#renderDOM"),
  patch: Symbol("#patch"),
  destroy: Symbol("#destroy")
};

export { AttributeValues, Attributes, External, Internal, camelToKebab, createUUID, forEach, getTypeTag, isEmptyObject, isFunction, isPlainObject, isString, isUndefined, kebabToCamel, log, sanitizeString };
//# sourceMappingURL=index.es.js.map
